import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import portal from './portal'
import localStoragePlugin from './plugins'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    portal,
  },
  plugins: [localStoragePlugin],
  strict: process.env.DEV,
})
